<script setup lang="ts">
import {onMounted} from 'vue';
import Toaster from '@/components/ui/toast/Toaster.vue';
import {ConfigProvider} from 'radix-vue';
import PaymentModal from "~/components/payments/PaymentModal.vue";

const useIdFunction = () => useId();
const loadingScreen = useTemplateRef('loadingScreen');
const logo = useTemplateRef('logo');

useHead({
  titleTemplate: (title: string) => title ? `${title} - Redlike` : 'Redlike'
})

onMounted(() => {
  setTimeout(() => {
    loadingScreen.value?.classList.add('fade-out');
    logo.value?.classList.add('scale-up');
  }, 100);

  setTimeout(() => {
    if (loadingScreen.value) {
      loadingScreen.value.style.display = 'none';
    }
  }, 300);

  const route = useRoute();
  const referralCode = route.query.ref;

  if (referralCode && typeof referralCode === 'string') {
    localStorage.setItem("referral_code", referralCode);
    console.log("[Referral] Zapisano kod referencyjny:", referralCode);
  }
});
</script>

<template>
  <NuxtLoadingIndicator color="#C936cc"/>
  <ConfigProvider :use-id="useIdFunction">
    <Toaster/>
    <NuxtLayout>
      <NuxtPage/>
    </NuxtLayout>
    <PaymentModal/>
  </ConfigProvider>
  <div ref="loadingScreen"
       class="fixed inset-0 flex flex-col items-center justify-center bg-white opacity-100 z-[9999999999] transition-opacity duration-300">
    <img ref="logo" src="~assets/main-logo.svg" alt="Logo Redlike"
         class="w-36 h-36 transform transition-transform duration-300"/>
    <div class="flex flex-col justify-center items-center absolute left-1/2 -translate-x-1/2 bottom-8">
      <span class="text-center text-gray text-sm mb-1">from</span>
      <span class="text-center text-black text-2xl font-bold">Redlike</span>
    </div>
  </div>
</template>

<style scoped>
.fade-out {
  opacity: 0;
}

.scale-up {
  transform: scale(1.5);
}
</style>
